// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCompletedSign_root__GO5Fb","text":"PlasmicCompletedSign_text__GtCUy"};